// import gsap from "gsap";
// import _ from "lodash";
import Cookies from "js-cookie";
import $ from "jquery";

const removeAllCountryNameCookies = () => {
  // Get all cookies
  const allCookies = Cookies.get();
  const cookieName = "countryName";

  // Loop through all cookies and remove the ones with the specified name
  for (const cookie in allCookies) {
    if (cookie === cookieName) {
      Cookies.remove(cookieName, { path: "" }); // You can specify the path if needed
      Cookies.remove(cookieName); // You can specify the path if needed
    }
  }
};

$(() => {
  $("#country-prefilled-option").change(function () {
    let countryName = $(this).val();
    if (countryName !== "null") {
      removeAllCountryNameCookies();
      Cookies.set("countryName", countryName, { expires: 30 });
      location.reload();
    }
  });
});
